/** Figma `5106:9909` — Admin dashboard page layout tokens. */

export const ADMIN_DASHBOARD_LAYOUT = {
  heroSubtitleColor: '#64748b',
  heroToMetricsGap: '30px',
  metricsToRecentGap: '36px',
  metricGridGap: 3,
  recentSectionHeaderGap: '39px',
  recentTitleColor: '#23262f',
  recentTitleLetterSpacing: '-0.4395px',
  searchWidth: 389,
  filterWidth: 225,
  toolbarGap: '11px',
  paginationMinHeight: 52,
  paginationSelectBg: '#f1f5f9',
} as const
